import { FC, useMemo } from "react"
import { useAppSelector } from "../../../hooks"
import { selectAuth } from "../../../redux/slice/auth"
import Label from "../../Assets/Label/Label"
import { TelegramIcon } from "../../../icons/telegramIcon"
import { MailIcon } from "../../../icons/mailIcon"
import { GlobeLightIcon } from "../../../icons/GlobeLightIcon"
import { PhoneIcon } from "../../../icons/phoneIcon"
import { useParams } from "react-router-dom"
import styles from "./FooterSupport.module.scss"

const FooterSupport: FC = () => {
  const { support, supportForCurrentProject } = useAppSelector(selectAuth)
  const { project_id } = useParams()

  const links = useMemo(() => {
    const telegram = project_id ? supportForCurrentProject.telegram : support.telegram
    const email = project_id ? supportForCurrentProject.email : support.email
    const site = project_id ? supportForCurrentProject.site : support.site
    const phone = project_id ? supportForCurrentProject.phone : support.phone

    return (
      <>
        {telegram && (
          <Label
            className={styles.label}
            txt={telegram}
            href={`https://t.me/${telegram}`}
            icon={<TelegramIcon />}
            isTarget
          />
        )}
        {email && <Label className={styles.label} txt={email} href={`mailto:${email}`} icon={<MailIcon />} />}
        {site && (
          <Label className={styles.label} txt={site} href={`https://${site}`} icon={<GlobeLightIcon />} isTarget />
        )}
        {phone && <Label className={styles.label} txt={phone} href={`tel:${phone}`} icon={<PhoneIcon />} />}
      </>
    )
  }, [project_id, support, supportForCurrentProject])

  return <div className={`support ${styles.support}`}>{links}</div>
}

export default FooterSupport
